import angular from 'angular';
import _ from 'lodash-es';
import APIV5 from '~/models/api';

/* globals Knitiv */

/**
 * @typedef {any} KTranslate
 * @param {import('angular').IQService} $q
 * @param {Knitiv.RootScope} $rootScope
 * @param {import('angular').ITimeoutService} $timeout
 * @returns {*}
 * @property {Function} request
 * @property {Function} remove
 * @property {Function} set
 */
export const KTranslate = /* @ngInject */ ($q, $rootScope, $timeout) => {
	let loading = false;

	/** @type {Object<import('@knitiv/api-client-javascript').KNode, any>} */
	const translations = {};

	const call = async () => {
		loading = false;

		/** @type {import('@knitiv/api-client-javascript').KNode[]} */
		const kids = [];

		for (const [kid, t] of Object.entries(translations)) {
			const text = t.text[$rootScope.appConfig.lang.code];
			if (text) {
				for (const item of t.items) {
					if (item.scope) {
						if ('setText' in item.scope && typeof item.scope.setText === 'function') {
							item.scope.setText(text);
						}
						else {
							item.scope.text = text;
						}
						item.scope.$apply();
					}
					item.deferred.resolve(text);
				}
			}
			else {
				// @ts-ignore
				kids.push(kid);
			}
		}

		if (kids.length > 0) {
			/** @type {any} */
			try {
				const result = await APIV5.instance.repreListSimple({ items: kids, mode: 'simple' }, { id: 'ktranslate.call' });
				// eslint-disable-next-line unicorn/no-array-for-each
				Object.entries(result.result).forEach(([kid, text]) => {
					if (translations[kid]) {
						translations[kid].text[$rootScope.appConfig.lang.code] = text;
						for (const item of translations[kid].items) {
							if (item.scope) {
								if ('setText' in item.scope && typeof item.scope.setText === 'function') {
									item.scope.setText(text);
								}
								else {
									item.scope.text = text;
								}
								item.scope.$apply();
							}
							item.deferred.resolve(text);
						}
					}
				});
				return result.result;
			}
			catch (/** @type {any} */ error) {
				for (const kid of kids) {
					for (const item of translations[kid].items) {
						item.deferred.reject(error);
					}
				}
			}
		}
		return false;
	};

	$rootScope.$on('changeLanguage', call);

	return {
		request: async (/** @type {any} */ scope, /** @type {import('@knitiv/api-client-javascript').KNode} */ kid) => {
			const deferred = $q.defer();
			let existingScope = false;

			if (kid in translations && $rootScope.appConfig.lang.code in translations[kid].text) {
				for (const item of translations[kid].items) {
					if (item.scope?.$id === scope?.$id) {
						existingScope = true;
					}
				}

				if (!existingScope) {
					translations[kid].items.push({ scope, deferred });
				}

				for (const item of translations[kid].items) {
					if (item.scope) {
						if ('setText' in item.scope && typeof item.scope.setText === 'function') {
							item.scope.setText(translations[kid].text[$rootScope.appConfig.lang.code]);
						}
						else {
							item.scope.text = translations[kid].text[$rootScope.appConfig.lang.code];
						}
					}
					deferred.resolve(translations[kid].text[$rootScope.appConfig.lang.code]);
				}
			}
			else {
				if (kid in translations) {
					translations[kid].items.push({ scope, deferred });
				}
				else {
					translations[kid] = {
						items:   [{ scope, deferred }],
						text:     {},
					};
				}
				if (!loading) {
					loading = true;
					const result = await $timeout(async () => call(), 250);
					return result && kid in result ? result[kid] : result;
				}
			}
			return deferred.promise;
		},

		remove: (/** @type {any} */ id) => {
			let translationIndex = translations.length - 1;
			while (translationIndex > 0) {
				_.remove(translations[translationIndex].items, item => item.scope.$id === id);
				if (translations[translationIndex].items.length === 0) {
					translations.splice(translationIndex, 1);
				}
				translationIndex--;
			}
		},

		set: (
			/** @type {any} */ scope,
			/** @type {import('@knitiv/api-client-javascript').KNode} */ kid,
			/** @type {string} */ text,
		) => {
			const deferred = $q.defer();
			if (kid in translations) {
				translations[kid].items.push({ scope, deferred });
			}
			else {
				translations[kid] = {
					items: [{ scope, deferred }],
					text:  {},
				};
			}
			if ($rootScope.context) {
				translations[kid].text[$rootScope.context?.lang.id] = text;
			}
			deferred.resolve(text);
			return deferred.promise;
		},
	};
};

export default angular.module('app')
	.factory('KTranslate', KTranslate);
